import { injectable, postConstruct } from 'inversify'
import { IStatement } from '@/model/statement'
import { MetaService, MetaServiceImpl } from './MetaService'
import { SearchQuery } from '@/model/search/search-query'
import { IReference } from '@/model/reference'

export interface StatementService extends MetaService<IStatement> {
  fetchStatements(query: SearchQuery): Promise<IStatement[]>
  addStatement(statement: IStatement, tags: string[], references: IReference[]): Promise<IStatement>
}

@injectable()
export class StatementServiceImpl extends MetaServiceImpl<IStatement> implements StatementService {
  @postConstruct()
  public initialize () {
    this.serviceName = 'statements'
  }

  public fetchStatements(query: SearchQuery): Promise<IStatement[]> {
  return this.getApiService().search<IStatement[]>('statements/search', { query: query })
  }

  public addStatement(statement: IStatement, tags: string[], references: IReference[]): Promise<IStatement> {
  return this.getApiService().post<IStatement>('statements', { 'statement': statement, 'tags': tags, 'references': references })
  }
}
